// extracted by mini-css-extract-plugin
export default {"container":"LSFDlz","text":"Wd24v3"};